<template>
  <div class="page container">
    <div class="container">
      <div class="column">
        <div class="content">
          <img src="http://www.espacowinnicottbsb.com.br/images/encontro.jpg" />
          <h3>XII Encontro Brasileiro sobre o pensamento de D. W. Winnicott</h3>
          <p>O grupo Winnicott Brasília terá o maior prazer em receber os amigos em 2017.

            Estando no centro do país e vivendo um momento político e social tão delicado, não conseguimos pensar em outro tema para nosso Encontro, senão em discutir Winnicott, Poder e Sofrimento Psíquico.

            Winnicott em seus estudos nos mostrou a importância da psicanálise “enxergar” e debater as questões políticas e sociais que interferem na estruturação do ambiente, dificultando com que ele possa ser suficientemente bom e causando sofrimento psíquico.

            Queremos discutir as diferentes formas de Poder e suas consequências na estruturação do Sujeito Psíquico.

            Esperamos por todos de 07 a 09 de setembro de 2017.

            Até Brasília.</p>
          <p><b>Programação do XII Encontro Brasileiro sobre o pensamento de Donald Winnicott.</b>
            <a href="http://www.espacowinnicottbsb.com.br/uploads/programacaoXIIEBDW.pdf" style="margin-left:5px">Baixar PDF</a>.</p>
        </div>
        <h3 class="is-size-4"></h3>
        <p class=""></p>
        
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'QuemSomos',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .container{
    max-width: 800px;
  }
</style>
